import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import TrafficIcon from "@material-ui/icons/Traffic";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import DirectionsTransitIcon from "@material-ui/icons/DirectionsTransit";
import GoogleMapReact from "google-map-react";
// import MarkerClusterer from "@google/markerclusterer";
import Geocode from "react-geocode";
import { UICheckbox } from "../../forms/InputComponents/Checkbox";
import { MarkerData } from "../../models/peer-support/markers";
import { GeoLocation } from "../../laco-common/base/models/address";

const DEFAULT_COORDINATES = { lat: 34.0522342, lng: -118.2436849 }; // Los Angeles
const DEFAULT_ZOOM: number = 14;
// NY { lat: 40.73, lng: -73.93 }

type LayerType = "TransitLayer" | "TrafficLayer" | "BicyclingLayer";

type MapViewProps = {
	address?: string;
	center?: GeoLocation;
	zoom?: number;
	clusteredMarkers?: MarkerData[];
	onBoundsUpdated?: (bounds?: google.maps.LatLngBounds, center?: google.maps.LatLng) => any;
	children?: React.ReactNode;
};

type MapViewState = {
	center: GeoLocation;
	zoom: number;
	zipCode: string;
	layers: LayerType[];
	loading: boolean;
};

class MapView extends Component<MapViewProps, MapViewState> {
	private googleMapRef: google.maps.Map;
	private googleRef;

	static defaultProps = {
		center: DEFAULT_COORDINATES,
		// zoom: DEFAULT_ZOOM,
	};

	state = {
		center: undefined,
		zoom: this.props.zoom || DEFAULT_ZOOM,
		zipCode: undefined,
		markers: [],
		layers: [],
		loading: true,
	};

	componentDidMount() {
		// const script = document.createElement("script");
		// script.src =
		// 	"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js";
		// script.async = true;
		// document.body.appendChild(script);
	}

	// componentDidMount() {
	// if (navigator.geolocation) {
	// 	navigator.geolocation.getCurrentPosition((position) => {
	// 		console.log("dana current position:", position);
	//
	// var geolocation = {
	// 	lat: position.coords.latitude,
	// 	lng: position.coords.longitude
	//   };
	// var circle = new google.maps.Circle(
	// 	{center: geolocation, radius: position.coords.accuracy});
	// autocomplete.setBounds(circle.getBounds());
	// 	});
	// }
	// }

	componentDidUpdate(prevProps: MapViewProps, prevState: MapViewState, snapshot) {
		if (
			this.googleMapRef &&
			this.props.clusteredMarkers &&
			this.props.clusteredMarkers !== prevProps.clusteredMarkers
		) {
			this.updateMarkers();
			return;
		}
		if (this.props.address && prevProps.address !== this.props.address) {
			this.updateAddress();
			return;
		}
		if (this.props.center && prevProps.center !== this.props.center) {
			this.updateCenter();
			return;
		}
	}

	onApiLoaded(map: google.maps.Map, maps) {
		console.log("onApiLoaded:", map, maps);
		this.googleMapRef = map;
		this.googleRef = maps;
		this.updateMarkers();
		this.setState({ loading: false });

		if (!this.props.onBoundsUpdated) return;
		const bounds: google.maps.LatLngBounds = map.getBounds();
		const center: google.maps.LatLng = map.getCenter();
		this.props.onBoundsUpdated(bounds, center);

		setTimeout(() => {
			map.addListener("bounds_changed", () => {
				const bounds: google.maps.LatLngBounds = map.getBounds();
				const center: google.maps.LatLng = map.getCenter();
				this.props.onBoundsUpdated(bounds, center);
				// searchBox.setBounds(map.getBounds());
			});
			// zoom_changed, center_changed
		}, 1);
	}

	setClusterMarkers() {
		// if (!this.googleMapRef || !this.props.clusteredMarkers || !this.props.clusteredMarkers.length) return;
		// const locations: GeoLocation[] = [];
		// this.props.clusteredMarkers.forEach((m: MarkerData) => {
		// 	locations.push({ lat: m.address.lat, lng: m.address.lng });
		// 	locations.push({ lat: m.address.lat, lng: m.address.lng });
		// 	locations.push({ lat: m.address.lat, lng: m.address.lng });
		// });
		// const markers =
		// 	locations &&
		// 	locations.map((location) => {
		// 		return new this.googleRef.Marker({ position: location });
		// 	});
		// const markerCluster = new MarkerClusterer(this.googleMapRef, markers, {
		// 	imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
		// 	gridSize: 10,
		// 	minimumClusterSize: 2,
		// });
	}

	updateAddress() {
		if (!this.props.address) return;
		console.log("updateAddress:", this.props.address);
		Geocode.fromAddress(this.props.address).then(
			(response) => {
				const { lat, lng } = response.results[0].geometry.location;
				console.log("from GEOCODE:", lat, lng);
				setTimeout(() => {
					this.setState({ center: { lat, lng }, zoom: DEFAULT_ZOOM - 2 });
				}, 0);
			},
			(error) => {
				console.error(error);
			}
		);
	}

	updateCenter() {
		const { lat, lng } = this.props.center;
		setTimeout(() => {
			this.setState({ center: { lat, lng }, zoom: DEFAULT_ZOOM - 2 });
		}, 0);
	}

	updateMarkers() {
		this.setClusterMarkers();
	}

	updateLayers(value: any, layer: LayerType) {
		const checked: boolean = value.target.checked as boolean;
		let layers: LayerType[] = this.state.layers;
		if (!checked) {
			// remove
			layers = layers.filter((l: LayerType) => l !== layer);
		} else {
			if (!layers.find((l: LayerType) => l == layer)) {
				layers.push(layer);
			}
		}
		this.setState({ layers });
	}

	render() {
		return (
			// Important! Always set the container height explicitly
			<>
				<div className="mapview-container" style={{ height: "55vh", width: "100%" }}>
					<GoogleMapReact
						className="border-radius-card"
						bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API, language: "en", region: "US" }}
						defaultCenter={DEFAULT_COORDINATES}
						center={this.state.center}
						yesIWantToUseGoogleMapApiInternals
						onGoogleApiLoaded={({ map, maps }) => this.onApiLoaded(map, maps)}
						defaultZoom={this.props.zoom}
						zoom={this.state.zoom}
						distanceToMouse={() => {}}
						layerTypes={[...this.state.layers]}
						options={{ streetViewControl: true, mapTypeControl: false }}
					>
						{this.state.loading && <CircularProgress />}
						{!this.state.loading && this.props.children}
						{/* <MapMarker
						lat={34.05496699999999}
						lng={-118.2427194}
						text="Dana My Marker"
						tooltip="Dana Tooltip"
					/>
					<MapMarker lat={34.0389419} lng={-118.2556773} text="Dana Downtown" tooltip="Dana Tooltip" /> */}
					</GoogleMapReact>
				</div>
				<div className="d-flex justify-content-end">
					<UICheckbox
						label={
							<span className="d-inline-flex align-items-center mt-1">
								<TrafficIcon className="mr-1" style={{ fontSize: "0.85rem" }} />
								Traffic
							</span>
						}
						onChange={(value: any) => {
							this.updateLayers(value, "TrafficLayer");
						}}
					/>
					<UICheckbox
						label={
							<span className="d-inline-flex align-items-center mt-1">
								<DirectionsTransitIcon className="mr-1" style={{ fontSize: "0.85rem" }} />
								Transit
							</span>
						}
						onChange={(value: any) => {
							this.updateLayers(value, "TransitLayer");
						}}
					/>
					<UICheckbox
						label={
							<span className="d-inline-flex align-items-center mt-1">
								<DirectionsBikeIcon className="mr-1" style={{ fontSize: "0.85rem" }} />
								Bicycle
							</span>
						}
						labelClassName="mr-1"
						onChange={(value: any) => {
							this.updateLayers(value, "BicyclingLayer");
						}}
					/>
				</div>
			</>
		);
	}
}

export default MapView;

// class MapContainer extends Component<IProvidedProps, any> {
// 	state = {
// 		selectedPlace: null,
// 	};

// 	onMarkerClick() {
// 		console.log("onMarkerClick");
// 	}

// 	onInfoWindowClose() {
// 		console.log("onInfoWindowClose");
// 	}

// 	render() {
// 		return (
// 			// zoom={14}
// 			<Map google={this.props.google} centerAroundCurrentLocation={true}>
// 				{/* name={"Current location"} */}
// 				<Marker onClick={this.onMarkerClick} />
// 				{/* onClose={this.onInfoWindowClose} */}
// 				{/* <InfoWindow>
// 					<div>
// 						<h1>{this.state.selectedPlace.name}</h1>
// 					</div>
// 				</InfoWindow> */}
// 			</Map>
// 		);
// 	}
// }

// export default GoogleApiWrapper({
// 	apiKey: process.env.REACT_APP_GOOGLE_MAPS_API,
// 	// LoadingContainer: LoadingContainer
// })(MapContainer);
